"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SMBAccountModal_1 = require("./SMBAccountModal");
exports.default = SMBAccountModal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/SMBAccountModal/index.js
// module id = 1724
// module chunks = 8